module.exports = __webpack_public_path__ + "img/1.dcd5dacc.jpg";